import React, { useContext, useEffect, useState } from 'react'
import axios from '../../../config/axios'
import { useTenant } from '../../../contexts/TenantContext'
import { Content } from './style'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import { Outlet, useNavigate, useOutletContext, useLocation } from 'react-router-dom'
import ModalContext from '../../../contexts/ModalContext'
import { TypeMainOutlet } from '..'
import StockContext from '../../../contexts/StockContext'
import { Filter, Header } from '../../../components/SubHeaderFilter/types'
import { PageHeader } from '../../../components/StandardPage'

export const stockFilterHeaders: Header[] = [
  { key: 'isActivated', label: 'Disponível', type: 'boolean' },
  { key: 'code', label: 'Código', type: 'string' },
  { key: 'material', label: 'Material', type: 'string' },
  { key: 'color', label: 'Cor', type: 'string' },
  { key: 'description', label: 'Descrição', type: 'string' },
  { key: 'quantities', label: 'Quantidade', type: 'quantity' },
  { key: 'prices', label: 'Preço', type: 'price' },
  { key: 'format', label: 'Formato', type: 'string' },
  { key: 'finishing', label: 'Acabamento', type: 'string' },
  { key: 'fabrication', label: 'Fabricação', type: 'string' },
  { key: 'heatTreatment', label: 'Tratamento Térmico', type: 'string' },
  { key: 'originCountry', label: 'País de origem', type: 'string' },
  { key: 'supplier', label: 'Fornecedor', type: 'string' },
  { key: 'stockStreet', label: 'Rua', type: 'string' },
  { key: 'shelf', label: 'Prateleira', type: 'string' },
  { key: 'stockLocation', label: 'Localização', type: 'string' },
  { key: 'ncm', label: 'Ncm', type: 'string' },
  { key: 'dimension1', label: 'Dimensão 1 (mm)', type: 'number' },
  { key: 'dimension2', label: 'Dimensão 2 (mm)', type: 'number' },
  { key: 'invoice', label: 'Nota Fiscal', type: 'string' },
  { key: 'density', label: 'Densidade', type: 'number' },
  { key: 'certificateUrl', label: 'Certificados', type: 'string' },
  { key: 'totalCmc', label: 'Total CMC', type: 'number' },
  { key: 'markup', label: 'Markup', type: 'number' },
  { key: 'trackingNumber', label: 'Número de Rastreamento', type: 'string' },
  { key: 'receivedDate', label: 'Data de Recebimento', type: 'date' },
  { key: 'purchaseOrder', label: 'Ordem de Compra', type: 'string' },
  { key: 'heatNumber', label: 'Número da Corrida', type: 'string' },
  { key: 'family', label: 'Família', type: 'string' },
  { key: 'characteristic', label: 'Característica', type: 'string' },
  { key: 'carrierCode', label: 'Código da transportadora', type: 'number' },
  { key: 'stockStatus', label: 'Status', type: 'string' }
]

export const resourceFilterHeaders: Header[] = [
  { key: 'isActivated', label: 'Disponível', type: 'boolean' },
  { key: 'name', label: 'Insumo/Aviamento', type: 'string' },
  { key: 'code', label: 'Código', type: 'string' },
  { key: 'category', label: 'Categoria', type: 'string' },
  { key: 'type', label: 'Tipo', type: 'string' },
  { key: 'color', label: 'Cor', type: 'string' },
  { key: 'description', label: 'Descrição', type: 'string' },
  { key: 'quantities', label: 'Quantidade', type: 'quantity' },
  { key: 'prices', label: 'Preço', type: 'price' },
  { key: 'dimension1', label: 'Dimensão 1 (mm)', type: 'number' },
  { key: 'dimension2', label: 'Dimensão 2 (mm)', type: 'number' },
  { key: 'material', label: 'Material', type: 'string' },
  { key: 'format', label: 'Formato', type: 'string' },
  { key: 'finishing', label: 'Acabamento', type: 'string' },
  { key: 'fabrication', label: 'Fabricação', type: 'string' },
  { key: 'ncm', label: 'Ncm', type: 'string' },
  { key: 'shelf', label: 'Prateleira', type: 'string' },
  { key: 'stockLocation', label: 'Localização', type: 'string' },
  { key: 'stockStreet', label: 'Rua', type: 'string' },
  { key: 'supplier', label: 'Fornecedor', type: 'string' },
  { key: 'markup', label: 'Markup', type: 'number' },
]

import TableFiltersContext from '../../../contexts/TableFiltersContext'
import resource from '../../../assets/home/resource.svg'
import receipt from '../../../assets/home/receipt.svg'
import { movementHeaders } from './utils'
import SalesStockDashboard, { SalesStockToolbar, useSalesStockState } from './SalesStock'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'

import { usePermissions } from '../../../hooks/usePermissions'

export interface StockOutletType {
  quantity: number
  setQuantity: React.Dispatch<React.SetStateAction<number>>
}

const steelTabs = [
  { path: '/panel/stock', image: stock, name: 'Matéria prima', permission: 'materia_prima', external: false },
  { path: '/panel/stock/resource', image: resource, name: 'Insumos', permission: 'insumos', external: false }
]

const fashionTabs = [
  { path: '/panel/stock', image: stock, name: 'Tecidos', permission: 'materia_prima', external: false },
  { path: '/panel/stock/resource', image: resource, name: 'Aviamentos', permission: 'insumos', external: false },
  { path: '/panel/stock/sales', image: receipt, name: 'Vendas', permission: 'vendas', external: false }
]

interface StockSubHeaderProps {
  tabIndexActived: number
  handleTabChange: (index: number) => void
  salesStockState?: ReturnType<typeof useSalesStockState>
  appliedFilters: Filter[]
  onApplyFilter: (f: Filter) => void
  onRemoveFilter: (index: number) => void
  onClearAllFilters: () => void
  stockSection: 'stock' | 'movement' | 'resource' | 'sales'
}

const StockSubHeader: React.FC<StockSubHeaderProps> = ({
  tabIndexActived,
  handleTabChange,
  salesStockState,
  appliedFilters,
  onApplyFilter,
  onRemoveFilter,
  onClearAllFilters,
  stockSection
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { setModalActive, setModalSection, setStockMode, setIsResourceModal } = useContext(ModalContext)
  const { resetContext, setRefresh: setContextRefresh, isLoading } = useContext(StockContext)
  const { hasPermission } = usePermissions()
  const [stockInfo, setStockInfo] = useState({ totalWeight: 0, totalItems: 0 })

  const fetchStockInfo = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/stock/getTotalStock`);
      setStockInfo(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados do estoque:', error);
    }
  };

  useEffect(() => {
    fetchStockInfo();
  }, []);

  const openModal = () => {
    resetContext()
    setIsResourceModal(false)
    if (isFashionTenant) {
      setStockMode('fashion')
    }
    setModalActive(true)
    setModalSection('addStockMenu')
  }

  const openResourceModal = () => {
    resetContext()
    setIsResourceModal(true)
    if (isFashionTenant) {
      setStockMode('fashion')
    }
    setModalActive(true)
    setModalSection('addStockMenu')
  }

  const { isFashionTenant } = useTenant()
  const baseTabs = isFashionTenant ? fashionTabs : steelTabs
  const visibleTabs = baseTabs.filter((t) => hasPermission(t.permission))

  const filteredHeaders = stockFilterHeaders.filter(header => {
    if (isFashionTenant) {
      return !['density', 'heatTreatment'].includes(header.key)
    } else {
      return header.key !== 'color'
    }
  })

  const filteredResourceHeaders = resourceFilterHeaders.filter(header => {
    if (isFashionTenant) {
      return true
    } else {
      return header.key !== 'color'
    }
  }).map(header => {
    if (header.key === 'name') {
      return { ...header, label: isFashionTenant ? 'Aviamento' : 'Insumo' }
    }
    return header
  })

  const headers = tabIndexActived === 1
    ? filteredResourceHeaders
    : (stockSection === 'movement' ? movementHeaders : filteredHeaders)

  const isSales = tabIndexActived === 2 && !!salesStockState
  const showFilterMenu = !isSales && (tabIndexActived === 0 || tabIndexActived === 1)

  const createButton = isSales
    ? undefined
    : tabIndexActived === 1
      ? { label: isFashionTenant ? 'Adicionar Aviamento' : 'Adicionar Insumo', onClick: openResourceModal }
      : tabIndexActived === 0
        ? { label: isFashionTenant ? 'Adicionar Tecido' : 'Adicionar Estoque', onClick: openModal }
        : undefined

  return (
    <PageHeader
      title="Estoque"
      tableName={tabIndexActived === 1 ? 'Resource' : tabIndexActived === 2 ? 'Product' : 'Stock'}
      moduleName={tabIndexActived === 1 ? (isFashionTenant ? 'Aviamentos' : 'Insumos') : tabIndexActived === 2 ? 'Produto Final' : (isFashionTenant ? 'Tecidos' : 'Estoque')}
      titleTooltip={`Peso total: ${stockInfo.totalWeight.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })} kg\nItens totais: ${stockInfo.totalItems}`}
      tabs={visibleTabs.map((tab) => ({ key: tab.path, label: tab.name, icon: tab.image }))}
      activeTab={
        visibleTabs.find(t => location.pathname === t.path)?.path ||
        visibleTabs.slice().sort((a, b) => b.path.length - a.path.length).find(t => location.pathname.startsWith(t.path))?.path ||
        visibleTabs[0]?.path
      }
      onTabChange={(key) => navigate(key)}
      onReload={() => setContextRefresh((prev: boolean) => !prev)}
      isLoading={isLoading}
      filterHeaders={showFilterMenu ? headers : undefined}
      appliedFilters={isSales ? undefined : appliedFilters}
      onApplyFilter={showFilterMenu ? onApplyFilter : undefined}
      onRemoveFilter={isSales ? undefined : onRemoveFilter}
      onClearAllFilters={isSales ? undefined : onClearAllFilters}
      createButton={createButton}
      extraActions={isSales && salesStockState ? <SalesStockToolbar state={salesStockState.toolbarState} /> : undefined}
    />
  )
}

const StockContent = () => {
  const location = useLocation()
  const { search } = useOutletContext<TypeMainOutlet>()
  const { stockFilters, setStockFilters, setMovementFilters } = useContext(TableFiltersContext)
  const { stockMode } = useContext(ModalContext)
  const { isFashionTenant } = useTenant()
  const isFashion = isFashionTenant || stockMode === 'fashion'
  const salesStock = useSalesStockState(isFashionTenant)
  const [quantity, setQuantity] = useState(50)

  const stockFiltersState = usePersistedFilters(isFashion ? 'stock_current_fashion' : 'stock_current_steel')
  const movementFiltersState = usePersistedFilters(isFashion ? 'stock_movement_fashion' : 'stock_movement_steel')
  const resourceFiltersState = usePersistedFilters(isFashion ? 'stock_resource_fashion' : 'stock_resource_steel')

  const activeFiltersState = (section: string) => {
    if (section === 'resource') return resourceFiltersState
    if (section === 'movement') return movementFiltersState
    return stockFiltersState
  }

  useEffect(() => {
    const mapped = stockFiltersState.appliedFilters.flatMap(f => {
      if (f.filterType === 'Intervalo' && f.value?.start && f.value?.end) {
        return [
          { field: f.label, type: 'É maior/igual que', text: f.value.start },
          { field: f.label, type: 'É menor/igual que', text: f.value.end }
        ]
      }
      let typeMapped = f.filterType
      if (f.filterType === 'equals') typeMapped = 'É igual a'
      else if (f.filterType === 'contains') typeMapped = 'Contém'
      else if (f.filterType === 'startsWith') typeMapped = 'Começa com'
      else if (f.filterType === 'endsWith') typeMapped = 'Acaba com'
      else if (f.filterType === 'not') typeMapped = 'É diferente de'
      else if (f.filterType === 'gt') typeMapped = 'É maior que'
      else if (f.filterType === 'lt') typeMapped = 'É menor que'
      else if (f.filterType === 'gte') typeMapped = 'É maior/igual que'
      else if (f.filterType === 'lte') typeMapped = 'É menor/igual que'
      else if (f.filterType === 'Antes de') typeMapped = 'É menor que'
      else if (f.filterType === 'Depois de') typeMapped = 'É maior que'
      else if (f.filterType === 'Igual a') typeMapped = 'É igual a'
      else if (f.filterType === 'Diferente de') typeMapped = 'É diferente de'
      else if (f.filterType === 'Maior que') typeMapped = 'É maior que'
      else if (f.filterType === 'Menor que') typeMapped = 'É menor que'

      let val = f.value
      if (f.fieldType === 'boolean') {
        val = f.value === 'true' || f.value === true
      }
      return [{ field: f.label, type: typeMapped, text: typeof val === 'object' && val !== null ? val : String(val) }]
    })
    setStockFilters(mapped)
  }, [stockFiltersState.appliedFilters, setStockFilters])

  useEffect(() => {
    const mapped = movementFiltersState.appliedFilters.flatMap(f => {
      if (f.filterType === 'Intervalo' && f.value?.start && f.value?.end) {
        return [
          { field: f.label, type: 'É maior/igual que', text: f.value.start },
          { field: f.label, type: 'É menor/igual que', text: f.value.end }
        ]
      }
      let typeMapped = f.filterType
      if (f.filterType === 'equals') typeMapped = 'É igual a'
      else if (f.filterType === 'contains') typeMapped = 'Contém'
      else if (f.filterType === 'startsWith') typeMapped = 'Começa com'
      else if (f.filterType === 'endsWith') typeMapped = 'Acaba com'
      else if (f.filterType === 'not') typeMapped = 'É diferente de'
      else if (f.filterType === 'gt') typeMapped = 'É maior que'
      else if (f.filterType === 'lt') typeMapped = 'É menor que'
      else if (f.filterType === 'gte') typeMapped = 'É maior/igual que'
      else if (f.filterType === 'lte') typeMapped = 'É menor/igual que'
      else if (f.filterType === 'Antes de') typeMapped = 'É menor que'
      else if (f.filterType === 'Depois de') typeMapped = 'É maior que'
      else if (f.filterType === 'Igual a') typeMapped = 'É igual a'
      else if (f.filterType === 'Diferente de') typeMapped = 'É diferente de'
      else if (f.filterType === 'Maior que') typeMapped = 'É maior que'
      else if (f.filterType === 'Menor que') typeMapped = 'É menor que'

      let val = f.value
      if (f.fieldType === 'boolean') {
        val = f.value === 'true' || f.value === true
      }
      return [{ field: f.label, type: typeMapped, text: typeof val === 'object' && val !== null ? val : String(val) }]
    })
    setMovementFilters(mapped)
  }, [movementFiltersState.appliedFilters, setMovementFilters])

  const navigate = useNavigate()
  const { hasPermission } = usePermissions()

  const [section, setSection] = useState<'stock' | 'movement' | 'resource' | 'sales'>('stock')
  const headerTabIndex = section === 'resource' ? 1 : section === 'sales' ? 2 : 0

  useEffect(() => {
    const basePath = '/panel/stock'
    if (!location.pathname.startsWith(basePath)) {
      setSection('stock')
      return
    }

    const remainder = location.pathname.slice(basePath.length)
    const segments = remainder.split('/').filter(segment => segment.length > 0)
    const primarySegment = segments[0] || ''

    const canMateriaPrima = hasPermission('materia_prima')
    const canInsumos = hasPermission('insumos')

    if (primarySegment === 'movement') {
      setSection('movement')
      return
    }

    if (['resource', 'create', 'edit', 'view'].includes(primarySegment)) {
      if (!canInsumos && canMateriaPrima) {
        navigate('/panel/stock', { replace: true })
        return
      }
      setSection('resource')
      return
    }

    if (primarySegment === 'sales') {
      setSection('sales')
      return
    }

    if (!canMateriaPrima && canInsumos) {
      navigate('/panel/stock/resource', { replace: true })
      return
    }

    setSection('stock')
  }, [location.pathname, hasPermission, navigate])

  const handleTabSelection = (index: number) => {
    if (index === 2 && isFashionTenant) {
      setSection('sales')
      return
    }

    if (index === 1) {
      setSection('resource')
      return
    }

    if (index === 0) {
      setSection('stock')
    }
  }

  const renderSubHeader = () => {
    return (
      <StockSubHeader
        tabIndexActived={headerTabIndex}
        handleTabChange={handleTabSelection}
        salesStockState={section === 'sales' ? salesStock : undefined}
        appliedFilters={activeFiltersState(section).appliedFilters}
        onApplyFilter={activeFiltersState(section).handleApplyFilter}
        onRemoveFilter={activeFiltersState(section).handleRemoveFilter}
        onClearAllFilters={activeFiltersState(section).handleClearAll}
        stockSection={section}
      />
    )
  }

  const { refresh: contextRefresh } = useContext(StockContext)

  const outletContext = {
    search,
    quantity,
    setQuantity,
    refresh: contextRefresh,
    appliedFilters: section === 'resource' ? resourceFiltersState.appliedFilters : [],
  }

  return (
    <>
      {renderSubHeader()}
      <Content>
        {section === 'sales' ? (
          <SalesStockDashboard
            state={salesStock.toolbarState}
            items={salesStock.items}
            filtered={salesStock.filtered}
            isLoading={salesStock.isLoading}
            expandedGroups={salesStock.expandedGroups}
            setExpandedGroups={salesStock.setExpandedGroups}
          />
        ) : (
          <Outlet context={outletContext} />
        )}
      </Content>
    </>
  )
}

export const StockResourceLayout = () => {
  const context = useOutletContext<any>()
  return <Outlet context={{ ...context }} />
}

export default StockContent